import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';
import { _CANCEL_PRICE_TABLE_CHANGE_, _DELETE_TAB_ } from './QuotationModel';

export default {
  name: 'quotation-actions',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getUpdatedRowsQuotation',
      'getQuotation',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    cancelUpdatePriceTable() {
      this.setToggle({ type: 'confirm_modal', bool: false });
      Events.$emit(_CANCEL_PRICE_TABLE_CHANGE_);
    },
    deleteTab() {
      this.close();
      Events.$emit(_DELETE_TAB_, this.selectedQuotation);
      window.scrollTo(0, 0);
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.deleteQuotation(this.selectedQuotation.id)
        .then(() => {
          this.close();
          this.$router.push('/admin/orcamentos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Orçamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    approveQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.updateStatus(this.selectedQuotation.id, 'approved', true)
        .then(() => {
          this.activeAlert({ message: 'Orçamento aprovado com sucesso', theme: 'success' });
          this.close();
          Events.$emit('update:pagination', false);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    updatePriceTable() {
      const params = {
        id: this.selectedQuotation.id,
        priceTable: this.selectedQuotation.service.price_table,
      };

      QuotationService.getUpdatedRows(params)
        .then(() => {
          this.setToggle({ type: 'confirm_modal', bool: false });
          this.getQuotation(this.selectedQuotation.id);
        });
    },
  },
};
